module.exports = __webpack_public_path__ + "img/big_logo.f54b7970.png";